// extracted by css-extract-rspack-plugin
export default {"centerWithoutBackground":"_276cd700"};